import type { CALENDAR_TYPE } from "../Models/Common";

import { getAuthLink } from "@/Services/TherapyApi/Calendars";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

const fetchAuthLinkActionHandler = async (provider: CALENDAR_TYPE): Promise<string | undefined> => {
  const resp = await getAuthLink(provider);

  if (hasValue(resp) && isValidString(resp.redirect_url)) {
    return resp.redirect_url;
  }

  return undefined;
};

export default fetchAuthLinkActionHandler;
